import React from "react";
import {useIntl} from "react-intl";
import {EMY_PRODUCT_STATUSES} from "../helpers/StatusHelpers";
import {AELabel} from "../../../../_emywork/components/AELabel";

export const EmyProductStatus = ({status = EMY_PRODUCT_STATUSES.UNDER_REVIEW.key}) => {
  const {formatMessage} = useIntl();

  return (
    <AELabel variant={EMY_PRODUCT_STATUSES[status].className} title={formatMessage({id:status})} />
  )
}

